import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../../lib/api";


const DEFAULTS = {
  "/": { title: "Yalı Yurt | Samsun Özel Erkek Öğrenci Yurdu", description: "Samsun Atakum'da OMÜ'ye 1 km mesafede, güvenli ve konforlu erkek öğrenci yurdu. Tek ve iki kişilik odalar, her odada özel banyo." },
  "/odalar": { title: "Odalar | Yalı Yurt Samsun", description: "Tek ve iki kişilik oda seçenekleri; her odada özel banyo & WC, mini buzdolabı ve sınırsız internet." },
  "/hizmetler": { title: "İmkanlar & Hizmetler | Yalı Yurt", description: "24 saat sıcak su, ev yemekleri, güvenlik, çamaşır, spor alanları ve sakin çalışma ortamı." },
  "/videolar": { title: "Tanıtım Videoları | Yalı Yurt", description: "Yalı Yurt yaşamını yakından keşfedin." },
  "/galeri": { title: "Galeri | Yalı Yurt Samsun", description: "Odalar, ortak alanlar ve yurt yaşamından kareler." },
  "/konum": { title: "Konum | Yalı Yurt Samsun", description: "Atakum Körfez Mahallesi'nde, OMÜ kampüsüne 1 km, tramvay durağına 100 metre." },
  "/nedenbiz": { title: "Neden Biz? | Yalı Yurt Samsun", description: "Yalı Yurt'u yakından tanıyın: deneyimli kadro, üniversite öğrencilerine özel yaşam alanı, güvenlik ve konforlu oda seçenekleri." },
  "/hakkimizda": { title: "Hakkımızda | Yalı Yurt", description: "2009'dan beri Samsun'da erkek öğrencilere güvenli ve huzurlu bir yaşam alanı." },
  "/iletisim": { title: "İletişim | Yalı Yurt Samsun", description: "Telefon, WhatsApp, adres, iletişim ve randevu formu." },
  "/blog": { title: "Blog | Yalı Yurt Samsun", description: "Yurt yaşamı ve öğrencilik üzerine yazılar." },
};

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SeoManager = () => {
  const { pathname } = useLocation();
  const [seoMap, setSeoMap] = useState({});

  useEffect(() => {
    axios.get(`${API}/seo`).then(({ data }) => {
      const map = {};
      (data.pages || []).forEach((p) => { map[p.page] = p; });
      setSeoMap(map);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const base = pathname.match(/^\/odalar\//) ? "/odalar" : pathname;
    const seo = seoMap[base] || DEFAULTS[base] || DEFAULTS["/"];
    const pageUrl = `${window.location.origin}${pathname}`;
    document.title = seo.title;
    setMeta("description", seo.description);
    setMeta("keywords", seo.keywords || "");
    setMeta("og:title", seo.title, "property");
    setMeta("og:description", seo.description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", pageUrl, "property");
    setMeta("og:image", `${window.location.origin}/og-image.jpg`, "property");
    setMeta("twitter:title", seo.title);
    setMeta("twitter:description", seo.description);
    setMeta("twitter:image", `${window.location.origin}/og-image.jpg`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", pageUrl);
  }, [pathname, seoMap]);

  return null;
};
